module.exports = __webpack_public_path__ + "static/img/13.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/13.jpg
// module id = AQC5
// module chunks = 36